module.exports = __webpack_public_path__ + "img/join-us-8.c0905e50.png";